import { cn } from '@nexelem/utils';
import { useDayPicker, DropdownProps } from 'react-day-picker';
import { setYear } from 'date-fns';
import { Button } from '../Button';
import { useEffect, useRef } from 'react';

export const YearsDropdown = (props: DropdownProps) => {
  const { goToMonth, months } = useDayPicker();
  const activeRef = useRef<HTMLButtonElement>(null);

  // scroll to the active year on mount
  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({
        block: 'center',
        behavior: 'auto',
      });
    }
  }, []);

  // scroll to the active year on change
  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    }
  }, [props.value]);

  return (
    <div className="flex max-h-40 flex-col gap-1 overflow-auto rounded-sm border border-border-container bg-surface-container p-1">
      {props.options?.map((option) => {
        const yearAction = setYear(months[0].date, option.value);
        const isActive = props.value === option.value;

        return (
          <Button
            disabled={option.disabled}
            key={option.label}
            ref={isActive ? activeRef : null}
            type="button"
            variant="text"
            className={cn(
              'h-9 w-20 shrink-0 rounded-full capitalize',
              isActive && 'border border-border-brand! bg-surface-focus-lighter text-text-brand!',
            )}
            onClick={() => goToMonth(yearAction)}
          >
            {option.label}
          </Button>
        );
      })}
    </div>
  );
};
